class OpPdpMatchWithBanner extends HTMLElement {
  constructor() {
    super();
    
    this.rawVariant = this.querySelector(
      'script[type="application/json"]#match-variant'
    ).innerHTML;
    this.processVariants();

    this.sizeBtn = document.querySelector('.size-confirm-btn');
    this.variantInput = document.getElementById('variantId');
  }

  processVariants() {
    const [id, model_size] = this.rawVariant.split('_');
    this.variant = { id, model_size };
  }

  connectedCallback() {


    subscribe(PUB_SUB_EVENTS.faceSizeSelection, (payload) => {
      this.variant = payload.data.variant;
      setTimeout(() => {
        this.querySelector('.selected-accessory').click();
      }, 1000);
    });

    if (this.sizeBtn && this.variantInput) {
      this.sizeBtn.addEventListener('click', () => {
        const newRaw = this.variantInput.value;
        if (newRaw && newRaw !== this.rawVariant) {
          this.rawVariant = newRaw;
          this.processVariants();
            // retrigger the click on the selected accessory
          const selected = this.querySelector('.selected-accessory') 
                            || this.accessoryItems[0];
          selected.click();
        }
      });
    }

    this.cliponHandleInput = this.querySelector("input[name='product-handle']");
    this.accessoryImages = this.querySelectorAll('.accessoryImage img');
    this.accessoryItems = this.querySelectorAll('.frameGridItem');
    const firstAccessory = this.accessoryItems[0];
    this.previewCliponCheckbox = this.querySelectorAll('.previewClipon');
    this.previousItem = this.accessoryItems[0];

    this.accessoryItems.forEach((item) => {
      item.addEventListener('click', (evt) => {
        this.clipTriggerClick(item, evt);
        this.previousItem = item;
        this.updateAccessoryBtn();
      });
      item.addEventListener('mouseenter', (evt) => this.clipTriggerClick(item, evt));
      item.addEventListener('mouseleave', (evt) => this.clipTriggerClick(this.previousItem, evt));
    });

    this.previewCliponCheckbox.forEach((checkbox) => {
      checkbox.addEventListener('click', () => {
        this.updateAccessoryImage(checkbox);
      });
    });

    firstAccessory.click();
  }

  clipTriggerClick(item, evt) {
    const variantSize = this.variant.model_size;

    if (evt.type === "click") this.accessoryItems.forEach((i) => i.classList.remove('tw-border-b-op-default-dark', 'selected-accessory', 'tw-border-b'));
    if (evt.type === "click" || evt.type === "mouseleave") item.classList.add('tw-border-b-op-default-dark', 'selected-accessory', 'tw-border-b');

    const lensDescription = item.dataset.lensColor;
    const frameDescription = item.dataset.frameColor;
    const imageUrl = item.dataset.image;
    const price = item.dataset.price;
    const compareAtPrice = item.dataset.compareAtPrice;
    const discount = item.dataset.discount;
    const ctaUrl = item.dataset.ctaUrl;
    const isNewness = item.dataset.newness === 'true';
    const addButtonId = item.dataset.buttonId;
    this.buttonElement = this.querySelector('#' + addButtonId);
    const inputHidden = item.dataset.inputHiddenId;
    this.inputHiddenElement = this.querySelector('#' + inputHidden);
    const inputProperties = item.dataset.inputPropertiesId;
    this.inputPropertiesElement = this.querySelector('#' + inputProperties);
    // this.firstVariantId = item.dataset.firstVariantId;

    // matchedVariantId is required for clip on size match
    this.matchedVariantId = item.getAttribute('data-' + variantSize);
    this.matchedVariantStock = item.getAttribute('data-stock-' + variantSize);
    this.cliponHandle = item.dataset.productHandle;

    if (this.buttonElement != null) {
      this.updateAddButton();
    }

    const priceElement = this.querySelector('.AccessoryPrice');
    const compareAtPriceElement = this.querySelector('.AccessoryCompareAtPrice');
    const priceDiscountElement = this.querySelector('.AccessoryDiscount');
    this.querySelector('.LensColor').textContent = lensDescription;
    this.querySelector('.FrameColor').textContent = frameDescription;
    this.querySelector('.AccessoryCta').setAttribute('href', ctaUrl);
    const newnessBadges = this.querySelectorAll('.newnessBadge');

    newnessBadges.forEach((badge) => {
      if (isNewness == true) {
        badge.classList.remove('tw-hidden');
      } else {
        badge.classList.add('tw-hidden');
      }
    });
    
    // check if the clip-on item is a preorder, and display a “Preorder” badge on the clip-on overlay in the PDP.
    const isPreorder = item.dataset.preorder;
    const preorderBadge = this.querySelector('.preorderBadge');
    preorderBadge && isPreorder ? preorderBadge?.classList.remove('tw-hidden') : preorderBadge?.classList.add('tw-hidden');

    this.accessoryImages.forEach((image) => {
      image.src = imageUrl;
      image.srcset = '';
    });

    this.previewCliponCheckbox.forEach((checkbox) => {
      checkbox.checked = false;
    });


    priceElement.textContent = price;
    if (discount > 0) {
      compareAtPriceElement.textContent = compareAtPrice;
      priceDiscountElement.textContent = discount + '% OFF';
      compareAtPriceElement?.classList.remove('tw-hidden');
      priceDiscountElement?.classList.remove('tw-hidden');
    } else {
      compareAtPriceElement?.classList.add('tw-hidden');
      priceDiscountElement?.classList.add('tw-hidden');
    }

  }

  updateAccessoryImage(checkbox) {
    const cliponFeaturedImage = this.querySelector('.selected-accessory').dataset.image;
    const previewCliponImageUrl = this.querySelector('.selected-accessory').dataset.cliponPreview;
    if (checkbox.checked) {
      this.accessoryImages.forEach((image) => {
        image.src = previewCliponImageUrl;
        image.srcset = '';
      });
    } else {
      this.accessoryImages.forEach((image) => {
        image.src = cliponFeaturedImage;
        image.srcset = '';
      });
    }
  }

    updateAccessoryBtn() {
      const productSelected = this.querySelector('.selected-accessory')
      const form = this.querySelector('.prod-form')
      const warningMess = this.querySelector('.prod-warning')
      const messageStatus1 = this.querySelector('.prod-status-1')
      const messageStatus2 = this.querySelector('.prod-status-2')
      if(productSelected.dataset.available == 'true') {
        const lenses = productSelected.dataset.color_values
        form?.classList.remove('tw-hidden')
        warningMess?.classList.add('tw-hidden')
        if(this.matchedVariantStock == 'false') {
          // Disable add-to-cart if variant size not available
          form?.classList.add('tw-hidden')
          warningMess?.classList.remove('tw-hidden')
          messageStatus1?.classList.add('tw-hidden')
          messageStatus2?.classList.remove('tw-hidden')
        }
      } else {
        if(productSelected.dataset.status == '1') {
          messageStatus2?.classList.add('tw-hidden')
          messageStatus1?.classList.remove('tw-hidden')
        } else {
          messageStatus1?.classList.add('tw-hidden')
          messageStatus2?.classList.remove('tw-hidden')
        }
        form?.classList.add('tw-hidden')
        warningMess?.classList.remove('tw-hidden')
      }
  }

  updateAddButton() {
    /* This function enables/disables the add to cart button */
    let buttonDisabled = true; /* If set to true it disables the add to cart button if the variant and the clip on accessory sizes don't match, by being set to false the button is always enabled */
    if (this.matchedVariantId != null) {
      buttonDisabled = false; /* Disable Button only if no matched Variant */
      // if (this.matchedVariantStock == 'true') {
      //   buttonDisabled = false;
      // } 
      this.inputHiddenElement.value = this.matchedVariantId;
      this.cliponHandleInput.value = this.cliponHandle;
      const productSelected = this.querySelector('.selected-accessory')
      this.inputPropertiesElement.value = productSelected.dataset.colors
    }
    if (buttonDisabled == true) {
      this.buttonElement.disabled = true;
    } else {
      this.buttonElement.disabled = false;
    }
  }
}



if (!customElements.get("op-pdp-match-with-banner")) {
  customElements.define("op-pdp-match-with-banner", OpPdpMatchWithBanner);
}